import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions.js'
import mutations from './mutations.js'
import modules from './modules'

Vue.use(Vuex)
// 这里为全局的，模块内的请在模块内动态注册
const store = new Vuex.Store({
    strict: true,
    modules,
    state: {
        messageParams: {}, // 消息参数
        yearList: [],
        userInfo: {},
        userAvatarDict: {
            '00': require('../assets/images/user/avatar-00.png'),
            '01': require('../assets/images/user/avatar-01.png'),
            '02': require('../assets/images/user/avatar-02.png'),
        },
        gradeVolumeList: [
            // {name: '3_1', label: '三年级上册'},
            // {name: '3_2', label: '三年级下册'},
            // {name: '4_1', label: '四年级上册'},
            // {name: '4_2', label: '四年级下册'},
            // {name: '5_1', label: '五年级上册'},
            // {name: '5_2', label: '五年级下册'},
            // {name: '6_1', label: '六年级上册'},
            // {name: '6_2', label: '六年级下册'},
            // {name: '7_1', label: '七年级上册'},
            // {name: '7_2', label: '七年级下册'},
            // {name: '8_1', label: '八年级上册'},
            // {name: '8_2', label: '八年级下册'},
        ],
        languageList: [
            { name: 'python_lite', label: 'Python3 lite', label1: 'Python' },
            { name: 'python_car', label: 'python3 car', label1: 'Python' },
            { name: 'mixgoce', label: 'python esp32-c3', label1: 'MixGo CE' },
        ],
        optionsArr: ["A", "B", "C", "D", "E", "F"],
        submitTypeList: [
            { name: 'PERSON', label: '个人', label1: '个人作品（每人都需要提交）' },
            { name: 'GROUP', label: '小组', label1: '小组作品（每组只需1人提交）' },
        ],
        workTypeList: [
            { name: 'TXT', label: '文本', label1: '富文本' },
            { name: 'ANNEX', label: '附件', label1: '附件' },
            { name: 'PROGRAMMING', label: '编程', label1: '在线编程' },
        ],
        resourceTypeList: [ // 资源类型
            // { name: 'VIDEO', label: '视频', label1: '视频材料' },
            // { name: 'READ', label: '阅读', label1: '阅读材料' },
        ],
        activityTypeList: [ // 活动类型
            { name: 'classroomJob', label: '课堂作业', value: 'CLASSROOM_JOB', },
            // { name: 'groupChat', label: '组内聊天', value: 'GROUP_CHITCHAT', },
            { name: 'questionnaire', label: '课堂问卷', value: 'CLASSROOM_QUESTION', },
            // { name: 'subjectDiscuss', label: '主题讨论', value: 'SUBJECT_DISCUSSION', },
            { name: 'test', label: '课堂练习', value: 'CLASSROOM_TEST', },
        ],
        worksTypeList: { // 作业 练习
            SINGLE_CHOICE: '客观题-单选题',
            MULTIPLE_CHOICE: '客观题-多选题',
            SUBJECTIVE: '主观题',
        },
        evaluationTypeList: [ // 评价
            { name: 'TASK', value: 'SINGLE_CHOICE', label: '任务评价-仅学生评价' },
            { name: 'UNIT', value: 'MULTIPLE_CHOICE', label: '单元评价-自评、同学互评、师评' },
        ],
        questionTypeList: [
            { name: 'radio', value: 'SINGLE_CHOICE', label: '单选题' },
            { name: 'checkbox', value: 'MULTIPLE_CHOICE', label: '多选题' },
            { name: 'blank', value: 'SUBJECTIVE', label: '填空题' },
        ],
        resourceInfoDict: {},
        networkInterfaces: window.networkInterfaces || '',//网络状态
        keepAliveList: [],
        gradeList: [
            {
                value: "三年级",
                code: "k3",
            },
            {
                value: "四年级",
                code: "k4",
            },
            {
                value: "五年级",
                code: "k5",
            },
            {
                value: "六年级",
                code: "k6",
            },
            {
                value: "七年级",
                code: "k7",
            },
            {
                value: "八年级",
                code: "k8",
            },
        ],
        courseCoverList: {
            cover_1: require("@/assets/images/course/cover_1.png"),
            cover_2: require("@/assets/images/course/cover_2.png"),
            cover_3: require("@/assets/images/course/cover_3.png"),
            cover_4: require("@/assets/images/course/cover_4.png"),
        },
   
        studentBookCoverList:{
            cover3_1:require("@/assets/images/book/3_cover1.png"),
            cover3_2:require("@/assets/images/book/3_cover2.png"),
            cover4_1:require("@/assets/images/book/4_cover1.png"),
            cover4_2:require("@/assets/images/book/4_cover2.png"),
            cover5_1:require("@/assets/images/book/5_cover1.png"),
            cover5_2:require("@/assets/images/book/5_cover2.png"),
            cover6_1:require("@/assets/images/book/6_cover1.png"),
            cover6_2:require("@/assets/images/book/6_cover2.png"),
            cover7_1:require("@/assets/images/book/7_cover1.png"),
            cover7_2:require("@/assets/images/book/7_cover2.png"),
            cover8_1:require("@/assets/images/book/8_cover1.png"),
            cover8_2:require("@/assets/images/book/8_cover2.png"),
        },
        currentCheckStatus: {
            INITIAL: ['草稿', 'status_5'],
            WAIT_REVIEW: ['待复审', 'status_4'],
            WAIT_FINAL_REVIEW: ['待终审', 'status_1'],
            REVIEW_REFUSE: ['复审驳回', 'status_3'],
            FINAL_REFUSE: ['终审驳回', 'status_3'],
            PASS: ['终审通过', 'status_2'],
        },
        identityMap: {
            TEACHER: '教师',
            STUDENT: '学生',
            SCHOOL_MANAGER: '校管',
            REDACT: '编辑老师',
            REVIEW_REDACT: '审核编辑',
            FINAL_REDACT: '审核负责人',
        }
    },
    getters: {
        gradeVolumeDict(state) {
            let result = {}
            state.gradeVolumeList.forEach(v => {
                v && (result[v.name] = v)
            })
            return result
        },
        submitTypeDict(state) {
            let result = {}
            state.submitTypeList.forEach(v => {
                v && (result[v.name] = v)
            })
            return result
        },
        workTypeDict(state) {
            let result = {}
            state.workTypeList.forEach(v => {
                v && (result[v.name] = v)
            })
            return result
        },
        activityTypeDict_name2value(state) {
            let result = {}
            state.activityTypeList.forEach(v => {
                v && (result[v.name] = v.value)
            })
            return result
        },
        activityTypeDict_value2name(state) {
            let result = {}
            state.activityTypeList.forEach(v => {
                v && (result[v.value] = v.name)
            })
            return result
        },
        questionType_name2value(state) {
            let result = {}
            state.questionTypeList.forEach(v => {
                v && (result[v.name] = v.value)
            })
            return result
        },
        questionType_value2name(state) {
            let result = {}
            state.questionTypeList.forEach(v => {
                v && (result[v.value] = v.name)
            })
            return result
        },
    },
    mutations,
    actions
});
export default store
